import facebookImg from "../../assets/images/socialNetworks/facebook.png";
import instagramImg from "../../assets/images/socialNetworks/instagram.png";
import twitterImg from "../../assets/images/socialNetworks/twitter.png";
import youtubeImg from "../../assets/images/socialNetworks/youtube.png";

export type ISocialNetwork = "instagram" | "facebook" | "youtube" | "twitter";

export const socialNetworksDictionary: {
  [key: string]: { img: string; link: string };
} = {
  facebook: {
    img: facebookImg,
    link: "https://www.facebook.com/LMDW.Whisky.fr",
  },
  instagram: {
    img: instagramImg,
    link: "https://www.instagram.com/maisonduwhisky/",
  },
  twitter: {
    img: twitterImg,
    link: "https://twitter.com/whisky_fr",
  },
  youtube: {
    img: youtubeImg,
    link: "https://www.youtube.com/channel/UCjz7KW3anqEQi6-7hWEmk3Q",
  },
};
